import { CalculationColumn } from "../../types/column-types"
import { onAnyStandardCell } from "../../helpers/helpers"
import { renderCalcPos } from "../../helpers/helpers"

export const idCalculatuionPositionColumn: CalculationColumn = {
    dataIndex: 'id',
    title: 'Номер позиции',
    width: 70,
    onCell: onAnyStandardCell,
    render: renderCalcPos (r => r.id)
}